import { useCallback, useContext } from 'react';
import { CustomerContext } from '../CustomerProvider';

const SYSTEM_COMPANY = 0;

export default function useCustomer() {
	const context = useContext(CustomerContext);
	if (!context) {
		throw new Error('useCustomer must be used within the CustomerProvider');
	}

	const { customer, tokenManager } = context;

	/**
	 * evaluates customer role(s) from provided role(s)
	 * @param coNum (number|string)
	 * @param arId (object|Array)
	 * @returns {boolean|Boolean}
	 */
	const hasCompanyRole = useCallback(
		(coNum, arId) => {
			const roles = customer.roles;
			if (Object.prototype.hasOwnProperty.call(roles, coNum)) {
				const isRoleList = Array.isArray(arId);
				let hasRoleForCompany = roles[coNum].some(role => {
					if (role.arId === 'SUPER') {
						return true;
					} else if (isRoleList) {
						return arId.includes(role.arId);
					}

					return arId === role.arId;
				});

				if (!hasRoleForCompany && parseInt(coNum) !== SYSTEM_COMPANY && Object.prototype.hasOwnProperty.call(roles, SYSTEM_COMPANY)) {
					hasRoleForCompany = roles[SYSTEM_COMPANY].some(role => role.arId === 'SUPER');
				}

				return hasRoleForCompany;
			}

			return false;
		},
		[customer]
	);

	const hasRole = useCallback(
		arId => {
			return hasCompanyRole(customer.coNum, arId);
		},
		[hasCompanyRole, customer]
	);

	const hasAllRoles = useCallback(
		(arIds = []) => {
			if (arIds.length === 0) {
				return false;
			}

			return arIds.every(arId => hasRole(arId));
		},
		[hasRole]
	);

	return {
		customer,
		hasCompanyRole,
		hasRole,
		hasAllRoles,
		tokenManager
	};
}
